export function getQueryParam(key: string, search?: string): string | null {
  if (typeof window === "undefined" && !search) {
    return null;
  }

  const effectiveSearch = search ?? window.location.search;
  const params = new URLSearchParams(effectiveSearch);
  return params.get(key);
}

export function getSessionTicketQueryParam(search?: string): string | null {
  return getQueryParam("sessionTicket", search);
}

export function getHtbQueryParam(search?: string): string | null {
  return getQueryParam("htb", search);
}

export function getThemeQueryParam(search?: string): string | null {
  return getQueryParam("theme", search);
}

export function getHsbQueryParam(search?: string): string | null {
  return getQueryParam("hsb", search);
}
